import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AttributeValueDetail from './components/AttributeValueDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageAttributeValue',
  components: {
    AttributeValueDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;